module.exports = __webpack_public_path__ + "static/media/greater.a129efd2.svg";